var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.726-9.321L7.027 7H10.3l2.784 3.723L16.53 7h.962l-3.978 4.297L18 17.296h-3.273l-3.024-4.043-3.741 4.043H7l4.274-4.617Zm-1.329-4.97H8.441l6.64 8.878h1.504l-6.64-8.878Z",
    fill: "#D7D3D1"
  })));
};
export { SvgTwitter as ReactComponent };
export default __webpack_public_path__ + "7eeed9539a0d29eb7a87aaa415c75166.svg";